import { IInboxFolder, InboxFolderType } from "../models/inbox.models";

export const INBOX_FOLDER: IInboxFolder[] = [
    {
      type: InboxFolderType.ALL,
      icon: 'MessageSquare',
      label: 'All Conversations',
      total: 0,
      unread_count: 0,
    },
    {
      type: InboxFolderType.MENTIONS,
      icon: 'AtSign',
      label: 'Mentions',
      total: 0,
      unread_count: 0,
    },
    {
      type: InboxFolderType.DRAFTS,
      icon: 'Pencil',
      label: 'Drafts',
      total: 0,
      unread_count: 0,
    },
    {
      type: InboxFolderType.SENT,
      icon: 'Send',
      label: 'Sent',
      total: 0,
      unread_count: 0,
    },
  ];
